import {
  Controller,
  Get,
  Post,
  Body,
  Patch,
  Param,
  Delete,
  HttpCode,
  HttpStatus,
  Query,
} from '@nestjs/common';
import { CountryService } from '../services/country.service';
import { UpdateCountryDto } from '../dto/update-country.dto';
import { CreateCountryDto } from '../dto/create-country.dto';

@Controller('countries')
export class CountryController {
  constructor(private readonly countryService: CountryService) {}

  @Post()
  @HttpCode(HttpStatus.CREATED)
  create(@Body() createCountryDto: CreateCountryDto) {
    return this.countryService.create(createCountryDto);
  }

  @Get()
  findAll(@Query('withStates') withStates?: string) {
    if (withStates === 'true') {
      return this.countryService.findAllWithStates();
    }
    return this.countryService.findAll();
  }

  @Get(':id')
  findOne(@Param('id') id: string, @Query('withStates') withStates?: string) {
    if (withStates === 'true') {
      return this.countryService.findOneWithStates(id);
    }
    return this.countryService.findOne(id);
  }

  @Get(':id/states')
  findStates(@Param('id') id: string) {
    return this.countryService.findOneWithStates(id);
  }

  @Patch(':id')
  update(@Param('id') id: string, @Body() updateCountryDto: UpdateCountryDto) {
    return this.countryService.update(id, updateCountryDto);
  }

  @Delete(':id')
  @HttpCode(HttpStatus.NO_CONTENT)
  remove(@Param('id') id: string, @Query('soft') soft?: string) {
    if (soft === 'true') {
      return this.countryService.softDelete(id);
    }
    return this.countryService.remove(id);
  }

  @Get('shipping-cost/:countryId')
  getShippingCost(@Param('countryId') countryId: string, @Query('stateId') stateId?: string) {
    return this.countryService.getShippingCost(countryId, stateId);
  }
}